// extracted by mini-css-extract-plugin
export default {"Loading":"Preloader_Loading__R0Hgr","circle":"Preloader_circle__CFhv-","spinner-border":"Preloader_spinner-border__NMHIt","spin":"Preloader_spin__uCUMB"};